import { FC } from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

interface ReportLoadingSkeletonProps {
  columns?: number;
}

export const ReportLoadingSkeleton: FC<ReportLoadingSkeletonProps> = (props) => {
  return (
    <>
      {Array.from({ length: 5 }).map((_, rowIndex) => (
        <tr key={rowIndex}>
          {Array.from({ length: props.columns || 15 }).map((_, colIndex) => (
            <td key={colIndex}>
              <Skeleton height={40} />
            </td>
          ))}
        </tr>
      ))}
    </>
  );
};
